import { AggregatedCompany } from './interfaces';
import editSvg from '../../../../assets/edit.svg';
import deleteSvg from '../../../../assets/delete.svg';

const CompanyList: React.FC<{
  companies: AggregatedCompany[];
  onEditClick: (company: AggregatedCompany) => void;
  onDeleteClick: (name: string) => void;
}> = ({ companies, onEditClick, onDeleteClick }) => {
  return (
    <div>
      <div style={{ ...styles.emailHeader, position: 'sticky', top: 0 }}>
        <span>Company List</span>
      </div>
      {companies
        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        .map((company, index) => (
          <Card
            key={index}
            name={company.name}
            markets={company.markets}
            units={company.units}
            onEdit={() => onEditClick(company)}
            onDelete={() => onDeleteClick(company.name)}
          />
        ))}
    </div>
  );
};

interface CardProps {
  name: string;
  markets: number;
  units: number;
  onEdit: () => void;
  onDelete: () => void;
}

const Card: React.FC<CardProps> = ({ name, markets, units, onEdit, onDelete }) => {
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <span>{name}</span>
        <div style={{ flex: 1 }}></div>
        <button style={styles.iconButton} onClick={onEdit}>
          <img src={editSvg} alt="logout" style={{ width: '1.6vh', height: '1.6vh' }} />
        </button>
        <div style={{ width: '0.8vh' }}></div>
        <button style={styles.iconButton} onClick={onDelete}>
          <img src={deleteSvg} alt="logout" style={{ width: '1.6vh', height: '1.6vh' }} />
        </button>
      </div>
      <div style={styles.cardDetails}>
        <span style={{ color: 'rgba(16, 29, 59, 0.6)' }}>Total markets: </span>
        <span>{markets}</span>
        <div style={{ width: '0.8vh' }} />
        <span style={{ color: 'rgba(16, 29, 59, 0.6)' }}>Total units: </span>
        <span>{units}</span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    margin: '0 auto',
  },
  emailHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8f8f9',
    color: 'rgba(16, 29, 59, 0.6)',
    height: '4.4vh',
    borderBottom: '0.1vh solid #e1e2e6',
    paddingLeft: '1.6vh',
    fontSize: '1.2vh',
    fontWeight: '700',
  },
  addButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'rgba(16, 29, 59, 0.6)',
    fontSize: '2vh',
    marginRight: '1.6vh',
    cursor: 'pointer',
  },
  card: {
    color: 'rgba(16, 29, 59, 1)',
    padding: '0.8vh 1.6vh',
    borderRadius: '0.4vh',
    borderBottom: '0.1vh solid #e1e2e6',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4vh',
    fontWeight: '400',
  },
  icons: {
    display: 'flex',
  },
  iconButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    padding: '0vh',
  },
  cardDetails: {
    display: 'flex',
    justifyContent: 'start',
    marginTop: '0.4vh',
    fontSize: '1.2vh',
    fontWeight: '400',
  },
};

export default CompanyList;
